import { Component } from '@angular/core';
import {
  FieldType,
  FormlyExtension,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { sharedHealthCondition2026, sharedHealthInsurer2026 } from '../../form-parts-definition_2026';
import { sharedRetirement2026 } from '../../form-parts-definition_2026';

@Component({
  selector: 'tpa-health-2026',
  templateUrl: './health-2026.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'tpa-wrapper__control' },
})
export class Health2026Component extends FieldType implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      open: false,
    },
  };

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    field.fieldGroup = [
      ...sharedHealthInsurer2026(),
      ...sharedHealthCondition2026(),
      sharedRetirement2026(),
    ];
  }
}
